<template>
  <v-container fluid class="container--style">
    <div>
      <v-snackbar class="new-alert" v-model="alert" :timeout="timeout" :color="alertType" top="top">
        {{this.alertMessage}}
        <v-icon color="white" flat @click="alert = false">close</v-icon>
      </v-snackbar>
    </div>
    <v-layout justify-end>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <v-btn
          style="margin-top:3%"
          color="#4376a1"
          @click="edit = true"
        >Agregar Documentación Complementaria</v-btn>
        <v-card
          v-for="(anexo,index) in anexos"
          :key="index"
          class="comentario v-card-new"
          color="#4376a1"
          dark
        >
          <v-card-title class="color">
            <v-layout>
              <v-chip>
                <v-avatar>
                  <v-icon dark>account_circle</v-icon>
                </v-avatar>
                {{anexo.nombreVisible}}
              </v-chip>
            </v-layout>
            <v-layout justify-end>
              <v-btn
                
                small
                color="#8fd2f8"
                v-on:click="downloadFile(anexo.path,anexo.nombre,false)"
              >
                <v-icon color="#384149" dark>save_alt</v-icon>
              </v-btn>
              <v-btn  small color="#8fd2f8" v-on:click="getAnexoABorrar(anexo)">
                <v-icon color="#384149" dark>delete</v-icon>
              </v-btn>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="edit" width="700px" persistent>
      <template v-slot:activator="{ on }"></template>
      <v-card class="new-card">
        <v-card-title>
          <span class="headline">Agregar Anexo Complementario</span>
        </v-card-title>
        <v-layout>
          <v-layout align-center justify-center>
            <v-flex md9 lg9 xs9 sm9>
              <v-layout>
                <v-flex md12 lg12 xs12 sm12>
                  <label class="left" for="sel1">Nombre de Archivo</label>
                  <input v-model="nombreArchivo" type="text" class="form-control" id="usr" />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-text-field
                  color="#384149"
                  label="Cargar documento"
                  @click="pickFile()"
                  v-model="FileName"
                  prepend-icon="attach_file"
                  :disabled="disabled"
                ></v-text-field>
                <input
                  color="#384149"
                  type="file"
                  id="file"
                  ref="myFiles"
                  style="display: none"
                  @change="previewFiles()"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4376a1" flat="flat" @click="edit = false">Cerrar</v-btn>
          <v-btn color="#394049" flat="flat" @click="submitFile()">Subir Archivo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="eliminar" width="500">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>
          <span class="headline">¿Está seguro de querer eliminar el archivo {{anexo.nombreVisible}}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4376a1" flat="flat" @click="eliminar = false">No, cancelar</v-btn>
          <v-btn color="#394049" flat="flat" @click="erase(anexo.id)">Sí, eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      eliminar: false,
      anexo: {},
      path1: "",
      path2: "",
      nombreArchivo: "",
      edit: false,
      content: "this.$route.params.id",
      anexos: [],
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      alertType: "",
      alertMessage: "",
      alert: false,
      timeout: 4000,
      docExiste: false,
      idDoc: "",
      path: "",
      disabled: false,
      file: "",
      fileToUpload: "",
      FileName: ""
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.verificaPath();
    }
  },
  created() {
    //console.log(this.$route.fullPath);
    this.verificaPath();
  },

  methods: {
    getAnexoABorrar(item) {
      this.anexo = item;
      this.eliminar = true;
    },
    erase(id) {
      axios
        .delete(
          process.env.ROOT_API + "/documento/eraseDoc?idCap=" + id,
          this.auth
        )
        .then(response => {
          this.anexos = response.data;
          this.eliminar = false;
          alert(response.data);
          this.getAnexos();
        })
        .catch(error => {
          alert(error.response.data);
        });
    },

    verificaPath() {
      if (this.$route.fullPath == "/documentosFinales/anexosComplementarios") {
        this.path1 =
          "/documento/getByTipo?tipo=AnexosComplementario&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=AnexosComplementario&nombre=";
      }
      if (this.$route.fullPath == "/documentos45/anexosComplementarios4") {
        this.path1 =
          "/documento/getByTipo?tipo=AnexosComplementarios4&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=AnexosComplementarios4&nombre=";
      }
      this.getAnexos();
    },
    getAnexos() {
      axios
        .get(process.env.ROOT_API + this.path1, this.auth)
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.anexos = response.data;
          //console.log(this.anexos);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");

          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    pickFile() {
      //console.log("entrando a pick file");
      //console.log(this.$refs["myFiles"]);
      this.$refs["myFiles"].click();
    },
    previewFiles() {
      //console.log(index);
      this.fileToUpload = this.$refs["myFiles"].files[0];
      //console.log(this.$refs["myFiles"].files);
      //console.log(this.filess);
      this.FileName = this.$refs["myFiles"].files[0].name;
    },
    submitFile() {
      let formData = new FormData();
      var name = this.nombreArchivo;
      var email = this.$session.getAll().email;
      //console.log("indice: " + index);

      formData.append("file", this.fileToUpload);
      //console.log("FORM DATA");
      //console.log(formData);
      axios
        .post(
          process.env.ROOT_API + this.path2 + this.nombreArchivo,
          formData,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          //console.log("SUCCESS!!");
          //console.log(response.data);
          //this.path = response.data;
          //this.filesDge.dge[index]["saved"] = "si";
          //this.filesDge.dge[index]["path"] = response.data[0];
          //this.filesDge.dge[index]["name"] = response.data[1];
          alert(
            "Archivo: " + response.data.nombre + " fue cargado exitosamente."
          );
          this.getAnexos();
          this.FileName = "";
          this.edit = false;
          //No fuerza la recarga
          //this.$router.push({path: `/capitulo/${this.$route.params.id}/informacion`})
        })
        .catch(error => {
          //console.log("FAILURE!!");
          //console.log(error.response.data);
          alert(error.response.data);
        });
    },

    downloadFile(pathFile, nameFile, view) {
      var pathCorrecto = this.convertPath(pathFile);
      //console.log(pathFile);
      //console.log("Descargando archivo ....");
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathCorrecto,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          if (view) {
            this.forceFileDownload2(response, nameFile);
          } else {
            this.forceFileDownload(response, nameFile);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    forceFileDownload2(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      window.open(url, "_blank");
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    }
  }
};
</script>

<style scoped>
.new-card {
  height: auto;
}

.new-alert {
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.v-card__title.color {
  font-size: 12px;
  padding: 5px;
}

.v-card__text {
  background-color: #4376a1;
  padding: 1%;
  text-align: justify;
}
.comentario {
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-radius: 5%;
}

.container--style {
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/dca/documentosPost/AnexosC.vue